import React from 'react';
import { useSelector } from 'react-redux';
import {
  AlertBanner,
  Button,
  ButtonIcon,
  Icon,
  InputField,
  Typography,
} from '@saviynt/design-system';

import { useLocalization } from '../../../../hooks';
import { type CopilotState } from '../../data-layer/types';
import { useAddAccessLogic } from '../../hooks/addAccessLogic';
import { useChatFlowController } from '../../hooks/useChatFlowController';

/**
 * AddAccessExpandedView
 */
function AddAccessExpandedView() {
  const { handleFormSubmit } = useChatFlowController();
  const formatMessage = useLocalization();
  const addAccessInputField = useSelector(
    (state: { copilot: CopilotState }) => state.copilot.ui.addAccessInputField
  );

  // AddAccess logic for entitlements - same as normal view
  const addAccessLogic = useAddAccessLogic(handleFormSubmit);

  return (
    <div className='p-6 max-w-4xl mx-auto'>
      {/* Render entitlement input fields */}
      <div className='mb-6'>
        {addAccessLogic.entitlements.map((ent, index) => (
          <div key={ent.id} className='AddAccess-EntitlementType mb-4'>
            <InputField
              name={`entitlement-${index}`}
              isDisabled={addAccessInputField}
              placeholder={formatMessage(
                'INTEGRATIONS.COPILOT.ADD_ACCESS_ENTER_ENTITLEMENT_TYPE',
                'Enter Entitlement type'
              )}
              label={
                <Typography kind='label' htmlFor={`entitlement-${index}`}>
                  {formatMessage(
                    'INTEGRATIONS.COPILOT.ADD_ACCESS_ENTITLEMENT_TYPE',
                    'Entitlement type'
                  )}
                </Typography>
              }
              value={ent.value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                addAccessLogic.handleChange(index, e.target.value);
              }}
            />
            {addAccessLogic.entitlements.length > 1 && (
              <ButtonIcon
                className='AddAccess-EntitlementType-Icon'
                size='small'
                kind='outlinedNeutral'
                icon={<Icon kind='delete' size='medium' />}
                onClick={() => addAccessLogic.handleRemoveEntitlement(index)}
              />
            )}
          </div>
        ))}

        <div style={{ padding: '1rem 0' }}>
          <Button
            type='button'
            kind='ghost'
            size='large'
            onClick={addAccessLogic.handleAddEntitlement}
            isDisabled={addAccessInputField}
            leftIcon={<Icon kind='Add' />}>
            {formatMessage(
              'INTEGRATIONS.COPILOT.ADD_ACCESS_ADD_NEW_ENTITLEMENT_TYPE',
              'Add Entitlement Type'
            )}
          </Button>

          <AlertBanner
            colorTheme='Warning'
            kind='low'
            title={formatMessage(
              'INTEGRATIONS.COPILOT.MAX_ENTITLEMENTS',
              'Maximum Entitlement',
              { MAX_ENTITLEMENTS: 6 }
            )}
            description={formatMessage(
              'INTEGRATIONS.COPILOT.MAX_ENTITLEMENTS_ADDED',
              'Maximum Entitlement Added'
            )}
            isVisible={addAccessLogic.isVisible}
            onCancel={addAccessLogic.onCancel}
          />
        </div>
      </div>
    </div>
  );
}

export default AddAccessExpandedView;
